<template>

  <div

    :class="[

      'page-shell',

      pageClass,

      'page-template-default',

      'wp-custom-logo',

      'wp-embed-responsive',

      'post-image-aligned-center',

      'sticky-menu-fade',

      'sticky-enabled',

      'both-sticky-menu',

      'no-sidebar',

      'nav-below-header',

      'separate-containers',

      'header-aligned-left',

      'dropdown-hover',

    ]"

  >

    <HeadNav

      selectedLanguage="en"

      :page="page"

      :gotodownload="gotodownload"

      :apk="apk"

    />

    <nav v-if="showBreadcrumb" class="shell-breadcrumb" aria-label="Breadcrumb">
      <template v-for="(item, index) in breadcrumbItems">
        <a v-if="item.href" :key="item.label + index" :href="item.href">{{ item.label }}</a>
        <span v-else :key="item.label + index" class="current">{{ item.label }}</span>
        <span v-if="index < breadcrumbItems.length - 1" :key="'sep-' + index" class="sep">/</span>
      </template>
    </nav>

    <div id="page" class="site grid-container container hfeed">

      <div id="content" class="site-content">

        <div id="primary" class="content-area">

          <main id="maincontent" class="site-main">

            <slot />

          </main>

        </div>

      </div>

    </div>

    <div

      v-if="$global.isMobileDevice() && showMobileDownload"

      id="fixed-bottom-btn"

      class="fix-bottom-btn"

      @click="gotodownload()"

    >

      Download WhatsApp Aero APK

    </div>

  </div>

</template>



<script>

import '@/css/base.scss';

import '@/css/index.scss';

import '@/css/malavida-theme.scss';

import '@/css/blog/blog-post-content.scss';

import HeadNav from '@/components/HeadNav.vue';

import apkDownload from '@/mixins/apkDownload';



export default {

  name: 'PageShell',

  components: { HeadNav },

  mixins: [apkDownload],

  props: {

    page: {

      type: String,

      required: true,

    },

    pageClass: {

      type: String,

      default: 'article-page',

    },

    showMobileDownload: {

      type: Boolean,

      default: false,

    },

  },

  computed: {

    showBreadcrumb() {

      return this.page !== 'home';

    },

    breadcrumbItems() {

      const pageMap = {
        download: 'Android APK',
        features: 'Features',
        install: 'Install Guide',
        update: 'Update Guide',
        antiban: 'Anti-Ban Guide',
        blogs: 'Blog',
        'blog-vs-wa': 'WhatsApp Aero vs Official WhatsApp',
        'blog-vs-gb': 'WhatsApp Aero vs GB WhatsApp',
        'blog-ios': 'WhatsApp Aero for iOS',
        disclaimer: 'Disclaimer',
        privacy: 'Privacy Policy',
        terms: 'Terms & Conditions',
      };

      const items = [
        { label: 'Home', href: '/' },
      ];

      if (this.page && this.page.indexOf('blog-') === 0) {
        items.push({ label: 'Blog', href: '/blog/' });
      }

      items.push({ label: pageMap[this.page] || 'Page' });
      return items;

    },

  },

};

</script>



<style lang="scss" scoped>

$mv-heading: #35548f;

$mv-text: #555;

$mv-link: #35548f;

$mv-green: #8cc37a;

$mv-green-hover: #7ab868;

$mv-border: #d4d4d4;
$mv-bg-soft: #f5f5f5;

.shell-breadcrumb {

  max-width: 1080px;

  margin: 0 auto;

  padding: 28px 16px 10px;

  font-family: 'Trebuchet MS', Helvetica, Arial, sans-serif;

  font-size: 15px;

  font-weight: 600;

  line-height: 1.4;

  color: #a7adb7;

  a {

    color: $mv-heading;

    text-decoration: none;

    &:hover {

      text-decoration: underline;

    }

  }

  .current {

    color: #a7adb7;

  }

  .sep {

    display: inline-block;

    margin: 0 14px;

    color: #b9bec7;

  }

}

.article-page ::v-deep .article-content,
.home-page ::v-deep .article-content {

  max-width: 1080px;

  margin: 24px auto 56px;

  padding: 28px 32px 52px;

  background: #fff;

  border: 1px solid #dfe7f0;

  border-radius: 8px;

  box-shadow: 0 18px 42px rgba(53, 84, 143, 0.08);



  // Malavida 顶部 Hero

  .aero-profile-head {

    padding: 24px 22px 18px;

    border-bottom: 1px solid $mv-border;

    margin: -4px -8px 22px;

    background: linear-gradient(180deg, #f7fafc 0%, #fff 100%);

    border-radius: 8px;

  }

  // 下载页 Hero：左侧信息 + 右侧下载按钮
  .aero-profile-head--download {
    padding: 28px 20px 24px;
    background: linear-gradient(180deg, #f5f8fc 0%, #fff 100%);
    border-bottom: 2px solid $mv-border;
    border-radius: 0 0 8px 8px;
    margin: 0 -16px 16px;

    .aero-hero-body {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 32px;
    }

    .aero-head-main {
      margin-bottom: 0;
      flex: 1;
      min-width: 0;
    }

    .aero-hero-side {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 14px;
      flex-shrink: 0;
      width: min(100%, 300px);
    }

    .download-zone {
      margin: 0;
      width: 100%;
      text-align: center;
    }

    .mv-download-btn,
    .primary-btn {
      width: 100%;
      min-width: 0;
    }

    .aero-meta-list {
      width: 100%;
      justify-content: space-between;
      gap: 8px 12px;
      padding: 12px 14px;
      background: #fff;
      border: 1px solid #dce3ec;
      border-radius: 6px;

      li {
        font-size: 13px;
        white-space: nowrap;
      }
    }
  }



  .aero-head-main {

    display: flex;

    gap: 20px;

    align-items: flex-start;

    margin-bottom: 20px;

  }



  .aero-app-icon {

    width: 96px;

    height: 96px;

    border-radius: 18px;

    flex-shrink: 0;

    border: 1px solid rgba(53, 84, 143, 0.14);

    box-shadow: 0 10px 24px rgba(53, 84, 143, 0.14);

  }



  .aero-head-text {

    flex: 1;

    min-width: 0;

  }



  .aero-platform {

    font-size: 13px;

    color: #888;

    text-transform: uppercase;

    letter-spacing: 0.04em;

    margin: 0 0 6px;

    font-weight: 700;

  }



  .aero-head-text h1 {

    font-size: 1.65rem;

    line-height: 1.25;

    margin: 0 0 8px;

    color: $mv-heading;

    font-weight: 700;

  }



  .aero-version-badge {

    margin: 0 0 10px;

    font-size: 15px;

    color: $mv-text;



    span {

      font-weight: 700;

      color: $mv-heading;

    }

  }



  .hero-subtitle {

    font-size: 1rem;

    color: $mv-text;

    line-height: 1.55;

    margin: 0;

  }



  .download-zone {

    text-align: center;

    margin: 20px 0 16px;

  }



  .mv-download-btn,

  .primary-btn,

  .download-btn-inline {

    display: inline-flex;

    flex-direction: column;

    align-items: center;

    justify-content: center;

    gap: 2px;

    min-width: 280px;

    max-width: 100%;

    min-height: 64px;

    padding: 10px 24px;

    background: $mv-green;

    color: #fff !important;

    border: none;

    border-radius: 5px;

    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.12) inset,
      0 10px 20px rgba(124, 174, 105, 0.24);

    font-family: 'Trebuchet MS', Helvetica, Arial, sans-serif;

    cursor: pointer;

    text-decoration: none;

    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;



    &:hover {

      background: $mv-green-hover;

      transform: translateY(-1px);

    }

  }



  .mv-download-title {

    font-size: 22px;

    font-weight: 700;

    line-height: 1.2;

  }



  .mv-download-sub {

    font-size: 14px;

    font-weight: 600;

    opacity: 0.95;

  }



  .aero-meta-list {

    list-style: none;

    margin: 0;

    padding: 0;

    display: flex;

    flex-wrap: wrap;

    gap: 8px 24px;

    justify-content: center;



    li {

      margin: 0;

      font-size: 14px;

      color: $mv-text;

    }



    .meta-label {

      font-weight: 700;

      color: $mv-heading;

      margin-right: 6px;

    }

  }



  // 截图横向滚动条（Malavida 风格）

  .aero-screenshots {

    margin: 20px 0 28px;

    padding: 18px;

    background: linear-gradient(180deg, #f7fafc 0%, #eef4fb 100%);

    border: 1px solid #dfe7f0;

    border-radius: 8px;

    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);

  }



  .aero-screenshots-scroll {

    display: flex;

    gap: 12px;

    overflow-x: auto;

    padding: 4px 4px 12px;

    scroll-snap-type: x mandatory;

    -webkit-overflow-scrolling: touch;



    img {

      height: 220px;

      width: auto;

      border-radius: 8px;

      border: 1px solid $mv-border;

      scroll-snap-align: start;

      flex-shrink: 0;

      background: #fff;

      box-shadow: 0 10px 24px rgba(53, 84, 143, 0.12);

    }

  }



  // 正文排版

  h1 {

    font-size: 1.65rem;

    line-height: 1.25;

    margin: 24px 0 16px;

    color: $mv-heading;

    font-weight: 700;

  }



  h2 {

    font-size: 1.35rem;

    margin: 38px 0 16px;

    color: $mv-heading;

    font-weight: 700;

    padding: 13px 16px;

    border: 1px solid #dfe7f0;

    border-left: 4px solid $mv-heading;

    border-radius: 0 6px 6px 0;

    background: linear-gradient(90deg, #f5f8fc 0%, #fff 72%);

    box-shadow: 0 6px 16px rgba(53, 84, 143, 0.05);

  }



  h3 {

    font-size: 1.05rem;

    margin: 22px 0 10px;

    color: $mv-heading;

    font-weight: 700;

    padding-bottom: 8px;

    border-bottom: 1px dashed #d7e0eb;

  }

  .article-step-heading {

    display: flex;

    align-items: center;

    gap: 12px;

    margin: 22px 0 12px;

    padding: 12px 14px;

    border: 1px solid #dce7f1;

    border-left: 4px solid $mv-green;

    border-radius: 8px;

    background:
      linear-gradient(90deg, rgba(140, 195, 122, 0.14) 0%, #fff 68%),
      #fff;

    box-shadow: 0 10px 24px rgba(53, 84, 143, 0.07);

    color: $mv-heading;

    font-size: 1.04rem;

    font-weight: 700;

    line-height: 1.35;

  }

  .article-step-heading--p {

    margin-bottom: 10px;

  }

  .article-step-badge {

    display: inline-flex;

    align-items: center;

    justify-content: center;

    flex: 0 0 auto;

    min-width: 72px;

    min-height: 32px;

    padding: 5px 10px;

    border-radius: 6px;

    background: $mv-heading;

    color: #fff;

    font-size: 13px;

    font-weight: 800;

    line-height: 1.1;

    box-shadow: 0 8px 16px rgba(53, 84, 143, 0.16);

  }

  .article-step-text {

    min-width: 0;

    color: #233d6f;

  }



  p,

  li {

    line-height: 1.65;

    margin-bottom: 12px;

    color: $mv-text;

    font-size: 16px;

  }



  ul,
  ol {
    list-style: none !important;
    list-style-type: none !important;
    padding-left: 0;
    margin-left: 0 !important;
    margin-bottom: 16px;

    li {
      list-style: none !important;
      list-style-type: none !important;
    }
  }



  img.content-image {

    width: 100%;

    max-width: 640px;

    height: auto;

    display: block;

    margin: 24px auto;

    border-radius: 8px;

    border: 1px solid $mv-border;

  }



  a {

    color: $mv-link;

    text-decoration: none;



    &:hover {

      text-decoration: underline;

    }

  }



  .download-cta {

    text-align: center;

    margin: 24px 0;

  }



  .content-table-wrap {

    margin: 16px 0 32px;

    overflow-x: auto;

  }



  .content-table {

    width: 100%;

    border-collapse: collapse;

    background: #fff;

    font-size: 15px;

    box-shadow: 0 10px 24px rgba(53, 84, 143, 0.06);

  }



  .content-table th,

  .content-table td {

    border: 1px solid $mv-border;

    padding: 11px 14px;

    text-align: left;

    vertical-align: middle;

  }



  .content-table th {

    font-weight: 700;

    color: $mv-heading;

    background: #f5f8fc;

  }



  .content-table td {

    color: $mv-text;

  }



  .content-table tbody tr:nth-child(even) td {

    background: #fafafa;

  }



  // 隐藏旧版 stats-grid（若内容里还有残留）

  .stats-grid {

    display: none;

  }

}



// 文章页：标题居中，列表显示圆点
.article-page ::v-deep .article-content {
  h1 {
    text-align: center;
  }

  article ul {
    list-style: disc !important;
    list-style-type: disc !important;
    padding-left: 1.5em;
    margin-left: 0 !important;
    margin-bottom: 16px;

    li {
      list-style: inherit !important;
      list-style-type: inherit !important;
      display: list-item;
      margin-bottom: 6px;
      padding-left: 0.15em;
    }
  }
}



@media (max-width: 768px) {

  .article-page ::v-deep .article-content,
.home-page ::v-deep .article-content {

    margin: 12px auto 32px;

    padding: 18px 16px 36px;

    .aero-head-main {

      flex-direction: column;

      align-items: center;

      text-align: center;

    }

    .aero-profile-head--download {
      padding: 20px 12px;

      .aero-hero-body {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;
      }

      .aero-hero-side {
        width: 100%;
      }

      .aero-meta-list {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;

        li {
          display: flex;
          justify-content: space-between;
          white-space: normal;
        }
      }
    }



    .aero-head-text h1 {

      font-size: 1.35rem;

    }



    .mv-download-btn,

    .primary-btn {

      width: 100%;

      min-width: 0;

    }



    .aero-screenshots-scroll img {

      height: 180px;

    }

    .article-step-heading {

      align-items: flex-start;

      gap: 10px;

      padding: 11px 12px;

    }

    .article-step-badge {

      min-width: 62px;

      min-height: 28px;

      font-size: 12px;

    }

  }

}

</style>

